import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { TIMELINE } from "../../data/content";

export default function Timeline() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  // move track horizontally as user scrolls through the pinned section
  const x = useTransform(scrollYProgress, [0, 1], ["2%", "-72%"]);

  return (
    <section id="timeline" ref={ref} className="relative h-[300vh] bg-navy-800">
      <div className="sticky top-0 flex h-screen flex-col justify-center overflow-hidden">
        <div className="mx-auto w-full max-w-[1440px] px-6 sm:px-12">
          <p className="mb-4 text-[11px] uppercase tracking-[0.4em] text-gold">The journey</p>
          <h2 className="mb-16 max-w-2xl font-heading text-4xl font-light text-offwhite sm:text-5xl">
            From a vendor’s discipline to a builder’s ambition.
          </h2>
        </div>

        <motion.div style={{ x }} className="flex gap-8 pl-6 sm:gap-12 sm:pl-12">
          {/* connecting beam */}
          <div className="pointer-events-none absolute left-0 top-1/2 hidden h-px w-full bg-gold/15 md:block" />
          {TIMELINE.map((t, i) => (
            <div
              key={i}
              data-cursor="hover"
              className="group relative w-[78vw] shrink-0 sm:w-[42vw] lg:w-[30vw]"
            >
              <div className="mb-6 flex items-center gap-4">
                <span className="h-3 w-3 rounded-full bg-gold transition-transform duration-500 group-hover:scale-150" />
                <span className="text-xs uppercase tracking-[0.3em] text-gold">{t.year}</span>
              </div>
              <div className="border-t border-gold/15 pt-8 transition-colors duration-500 group-hover:border-gold/50">
                <h3 className="font-heading text-3xl font-light text-offwhite sm:text-4xl">{t.title}</h3>
                <p className="mt-4 max-w-sm text-sm font-light leading-relaxed text-offwhite/55">{t.text}</p>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
